import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';
import { selectAddCustomerParentGroup } from '../actions/select-add-customer-parent-group.actions';

@Injectable()
export class SelectAddCustomerParentGroupEffects {
  constructor(
    private actions$: Actions,
    private router: Router,
  ) {}

  selectAddCustomerParentGroup$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(selectAddCustomerParentGroup),
        tap(() => {
          this.router.navigateByUrl('/customers/add');
        }),
      ),
    { dispatch: false },
  );
}
